import React, { useState, useEffect, useRef } from "react";
import { HiArrowLeft } from "react-icons/hi2";
import { FaCamera } from "react-icons/fa";
import { Navbar, Button } from "flowbite-react";
import NicFront from "../img/nic-front.png";
import { useSearchParams, useNavigate } from "react-router-dom";
import { MdCheckCircle } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";
import "./styles.css";
import { handleImageUpload } from "./handler"
const NicDetails = (props) => {
  const cssForImageCard = {
    success : {
      imageDiv: 'mt-2 mb-10 custom-card-success border rounded-md items-center shadow-none p-10',
    },
    standard : {
      imageDiv: 'mt-2 mb-10 custom-card border rounded-md items-center shadow-none p-10',
    }
  }
  let [searchParams, setSearchParams] = useSearchParams();
  const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));
  let [frontNric, setFrontNric] = useState();
  let [backNric, setBackNric] = useState();
  const navigate = useNavigate();
  const frontNicRef = useRef(null);
  const backlNicRef = useRef(null);
  let [validationFront, setValidationFront] = useState({
    show: false,
    message: "",
    class: "",
  });
  let [validationBack, setValidationBack] = useState({
    show: false,
    message: "",
    class: "",
  });
  let [userUploadedFrontNric, setUserUploadedFrontNric] = useState(false)
  let [userUploadedBackNric, setUserUploadedBackNric] = useState(false)
  let [submitFrontButtonType, setFrontSubmitButtonType] = useState('')
  let [submitBackButtonType, setSubmitBackButtonType] = useState('')
  let [frontNricUploading, setFrontNricUploading] = useState(false)
  let [backNricUploading, setBackNricUploading] = useState(false)
  let [validationOnSubmit, setValidationOnSubmit] = useState(false)

  useEffect(() => {
    setFrontNric(NicFront);
    setFrontSubmitButtonType('Upload')
    setBackNric(NicFront);
    setSubmitBackButtonType('Upload')
    for (let requiredItems of props.memberRequirement.requiredDocuments[props.itemIndex].requiredItems) {
      if ( requiredItems.value !== "" && requiredItems.itemName === "frontSide") {
        setUserUploadedFrontNric(true)
        setFrontSubmitButtonType('Replace')
        setFrontNric(props.memberRequirement && requiredItems.url);
      } 
      if ( requiredItems.value !== "" && requiredItems.itemName === "backSide") {
        setUserUploadedBackNric(true)
        setSubmitBackButtonType('Replace')
        setBackNric(props.memberRequirement && requiredItems.url);
      }
    }
  }, []);

  const handleFrontNricClick = () => {
    frontNicRef.current.click();
  };
  const handleBackNricClick = () => {
    backlNicRef.current.click();
  };

  const handleFileChange = async (e, itemName) => {
    let file = e.target.files[0];
    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type) || file.size/1000000 > 7) {
      if (itemName === "backSide") {
        setValidationBack({
          show: true,
          message:
            "Invalid image. Only images of type png, jpg, jpeg with size below 7mb can be uploaded",
          class: "error-msg",
        });
        return
      } else {
        setValidationFront({
          show: true,
          message:
            "Invalid image. Only images of type png, jpg, jpeg with size below 7mb can be uploaded",
          class: "error-msg",
        });
      }
      return;
    }
    if (itemName === "backSide") {

      setBackNricUploading(() => true)
      await handleImageUpload(file, itemName, "nationalIdentityCard", setBackNric, setValidationBack, setUserUploadedBackNric, setSubmitBackButtonType,
      props.memberRequirement,  props.setMemberRequirement,props.itemIndex, navigate, selectedProfileType.profileId)
    } else {
      setFrontNricUploading(() => true)
      await handleImageUpload(file, itemName, "nationalIdentityCard", setFrontNric, setValidationFront, setUserUploadedFrontNric, setFrontSubmitButtonType,
      props.memberRequirement,  props.setMemberRequirement,props.itemIndex, navigate, selectedProfileType.profileId)
    }
      setFrontNricUploading(false)
      setBackNricUploading(() => false)
}


  return (
    <>
      <Navbar fluid={true} rounded={true} className="shadow mb-3" style={{position:'fixed', width:'100%', top:'0'}}>
        <Navbar.Brand
          onClick={() => {
            props.setOpenUploadDocument({
              openDocument: false,
              documentType: "",
            });
          }}
        >
          <HiArrowLeft className="h-10 w-5 ml-2" />
        </Navbar.Brand>
      </Navbar>
      <div className="p-6 max-w-md m-auto" style={{paddingTop:'80px'}}>
        <h5 className="text-2xl mb-2 font-bold tracking-tight text-gray-900 dark:text-white">
          National Identity Card
        </h5>
        <p className="mb-8 text-gray-600">
          Below are the required document to setup Rydesend account.
        </p>
        { validationOnSubmit && 
          <div className="error-msg">
            <span>Need to Upload both the sides of the NRIC before submitting for verification</span>
          </div>
        }
        {
          userUploadedFrontNric && 
          <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white" style={{paddingRight: '10px'}}>
            <MdCheckCircle style = {{ color: '#15BE44' }}/>
          </div>
        }

        <label className="font-bold tracking-tight text-gray-900" >
          Front Side
        </label>

        <div 
        className={ userUploadedFrontNric ?  cssForImageCard.success.imageDiv : cssForImageCard.standard.imageDiv}
        >
          {validationFront.show && (
            <div className={validationFront.class}>
              <span>{validationFront.message}</span>
            </div>
          )}
          <img src={frontNric} className="w-auto m-auto" alt="Ryde" />
          <p className="text-xs text-gray-400 tracking-tight mt-2">
            <i>Ensure photo is clear with all four sides visible.</i>
          </p>
          <Button
            pill={true}
            className="mt-5 m-auto w-sm pr-4"
            onClick={handleFrontNricClick}
          >
            {
              frontNricUploading ? <BsThreeDots className="h-5 w-10" /> : <FaCamera className="h-5 w-10" />
            }
            
            <label class="relative cursor-pointer rounded-md font-medium">
              <span>{frontNricUploading ? 'Saving' : userUploadedFrontNric ? 'Replace' : 'Upload' }</span>
            </label>
          </Button>
          <input
            id="file-upload"
            name="file-upload"
            type="file"
            // class="sr-only"
            style={{ display: "none", width: "0px" }}
            ref={frontNicRef}
            onChange={async (event) => {
              setFrontNricUploading(true)
              await handleFileChange(event, "frontSide");
              setFrontNricUploading(false)
            }}
          />
        </div>

        {
          userUploadedBackNric && 
          <div class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white" style={{paddingRight: '10px'}}>
            <MdCheckCircle style = {{ color: '#15BE44' }}/>
          </div>
        }

        <label className="font-bold tracking-tight text-gray-900">
          Back Side
        </label>
        <div className={ userUploadedBackNric ?  cssForImageCard.success.imageDiv : cssForImageCard.standard.imageDiv}>
          {validationBack.show && (
            <div className={validationBack.class}>
              <span>{validationBack.message}</span>
            </div>
          )}
          <img src={backNric} className="w-auto m-auto" alt="Ryde" />
          <p className="text-xs text-gray-400 tracking-tight mt-2">
            <i>Ensure photo is clear with all four sides visible.</i>
          </p>
          <Button
            pill={true}
            className="mt-5 m-auto w-sm pr-4"
            onClick={handleBackNricClick}
          >
            {
              backNricUploading ? <BsThreeDots className="h-5 w-10" /> : <FaCamera className="h-5 w-10" />
            }
            
            <label class="relative cursor-pointer rounded-md font-medium">
              <span>{backNricUploading ? 'Saving' : userUploadedBackNric ? 'Replace' : 'Upload' }</span>
            </label>

          </Button>
          <input
            id="file-upload-backside"
            name="file-upload"
            type="file"
            // class="sr-only"
            style={{ display: "none", width: "0px" }}
            ref={backlNicRef}
            onChange={async (event) => {
              setBackNricUploading(true)
              await handleFileChange(event, "backSide");
              setBackNricUploading(false)
            }}
          />
        </div>
        <Button className='bg-primary w-full mt-5' pill={true} disabled={false} onClick={()=>{
          if(userUploadedFrontNric && userUploadedFrontNric ) {
            props.setOpenUploadDocument({
              openDocument: false,
              documentType: "",
            });
          } else {
            setValidationOnSubmit(true)
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
          }
        }}>
                    Save
                  </Button>
      </div>
    </>
  );
};

export default NicDetails;
